enum PLAYER_STATES {
  PLAYING = 0,
  PAUSED = 1,
  ENDED = 2,
}

export { PLAYER_STATES };
